import { Box } from '@mui/material'
import { useIntl } from 'react-intl'

import { tokens } from '@configuration/theme'
import Card from '@base/Card/Card.component'
import ShieldIcon from '@icons/Shield.icon'

// Placeholder tab. Kratos has `totp.enabled: true` server-side already, so
// wiring the real flow is a UI-only change — render the totp group's QR
// image + secret input + verification code field from `flow.ui.nodes`,
// submit `method=totp`. Deferred until the team commits to enabling MFA.
const TwoFactorPanel = () => {
  const intl = useIntl()

  return (
    <Card
      dataTestId='two-factor-panel'
      sx={{
        minHeight: '360px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          gap: 1.75,
          padding: '28px 20px',
        }}
      >
        <Box
          sx={{
            width: 56,
            height: 56,
            borderRadius: tokens.radiusPill,
            background: tokens.versatileViolet10,
            color: tokens.versatileViolet,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <ShieldIcon width='26' height='26' />
        </Box>
        <Box component='h3' sx={{ fontSize: 18, fontWeight: 500, m: 0 }}>
          {intl.formatMessage({ id: 'settings.twoFactor.title' })}
        </Box>
        <Box
          component='p'
          sx={{ fontSize: 14, color: tokens.businessBlack60, m: 0, maxWidth: 380, lineHeight: 1.5 }}
        >
          {intl.formatMessage({ id: 'settings.twoFactor.body' })}
        </Box>
        <Box
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 0.75,
            height: 24,
            padding: '0 10px',
            borderRadius: tokens.radiusSm,
            fontSize: 12,
            fontWeight: 500,
            background: tokens.businessBlack5Solid,
            color: tokens.businessBlack60,
          }}
        >
          <Box
            sx={{
              width: 6,
              height: 6,
              borderRadius: tokens.radiusPill,
              background: 'currentColor',
            }}
          />
          {intl.formatMessage({ id: 'settings.twoFactor.comingSoon' })}
        </Box>
      </Box>
    </Card>
  )
}

export default TwoFactorPanel
